import React from 'react';
import Box from '@amzn/awsui-components-console/box';
import Button from '@amzn/awsui-components-console/button';
import Container from '@amzn/awsui-components-console/container';
import SpaceBetween from '@amzn/awsui-components-console/space-between';
import { PILOT_URL } from 'src/features/landing/constants';
import FooterBar from 'src/common/ui/FooterBar';
import styles from './Footer.module.scss';

const Footer = () => (
  <footer>
    {/* CTA Section */}
    <div className={styles.ctaWrapper}>
      <Container>
        <SpaceBetween size="l" alignItems="center">
          <SpaceBetween size="s" alignItems="center">
            <Box
              variant="h2"
              fontSize="heading-xl"
              fontWeight="bold"
              textAlign="center"
            >
              Ready to get started?
            </Box>
            <Box variant="p" textAlign="center" color="text-body-secondary">
              Submit an onboarding request and our team will set up your
              namespace, configure permissions, and get you translating.
            </Box>
          </SpaceBetween>
          <Button
            variant="primary"
            iconName="external"
            iconAlign="right"
            href={PILOT_URL}
            target="_blank"
          >
            Join Our Pilot
          </Button>
        </SpaceBetween>
      </Container>
    </div>

    {/* Footer Bar */}
    <FooterBar />
  </footer>
);

export default Footer;
